import { gql } from 'graphql.macro';

export const ReassignAllDepots = gql`
  mutation moveSHEQManagerDepots($movingManagerEmployeeId: Int!, $receivingManagerEmployeeId: Int!) {
    moveSHEQManagerDepots(movingManagerEmployeeId: $movingManagerEmployeeId, receivingManagerEmployeeId: $receivingManagerEmployeeId)
  }
`;